// @mui
import { alpha, styled } from '@mui/material/styles';
import {  ListItemIcon, ListSubheader, ListItemButton } from '@mui/material';
// config
import { ICON, NAV } from '../../../config';

// ----------------------------------------------------------------------

export const ListItemStyle =  styled(ListItemButton, {
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'caption',
})(({ active, disabled, depth, caption, theme }) => {
    const isLight = theme.palette.mode === 'light';

    const subItem = depth !== 1;

    const activeStyle = {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        ...(!isLight && {
            color: theme.palette.primary.light,
        }),
    };

    const activeSubStyle = {
        color: theme.palette.text.primary,
        backgroundColor: alpha(theme.palette.primary.main, 0.06),
        borderLeft: `2px solid ${theme.palette.primary.main}`,
        paddingLeft: theme.spacing(1.25),
    };

    return {
        position: 'relative',
        textTransform: 'capitalize',
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        color: theme.palette.text.secondary,
        borderRadius: theme.shape.borderRadius,
        height: NAV.H_DASHBOARD_ITEM,
        // Sub item
        ...(subItem && {
            height: NAV.H_DASHBOARD_ITEM_SUB,
            ...(depth > 2 && {
                paddingLeft: theme.spacing(depth),
            }),
            ...(caption && {
                height: NAV.H_DASHBOARD_ITEM,
            }),
        }),
        // Active item
        ...(active && {
            ...activeStyle,
            '&:hover': {
                ...activeStyle,
            },
        }),
        // Active sub item
        ...(subItem &&
      active && {
            ...activeSubStyle,
            '&:hover': {
                ...activeSubStyle,
            },
        }),
        // Disabled
        ...(disabled && {
            '&.Mui-disabled': {
                opacity: 0.64,
            },
        }),
    };
});

// ----------------------------------------------------------------------

export const ListItemIconStyle  = styled(ListItemIcon)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: ICON.NAVBAR_ITEM,
    height: ICON.NAVBAR_ITEM,
    minWidth: 32,
    marginRight: 8,
});


// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled(ListSubheader)(({ theme }) => ({
    ...theme.typography.overline,
    fontSize: 11,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: theme.palette.text.secondary,
    backgroundColor: 'transparent',
}));

// ----------------------------------------------------------------------

export const ListDotIcon = styled('span', {
    shouldForwardProp: (prop) => prop !== 'active',
})(({ active, theme }) => ({
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.palette.text.disabled,
    transition: theme.transitions.create(['transform', 'background-color'], {
        duration: theme.transitions.duration.shorter,
    }),
    ...(active && {
        transform: 'scale(1.5)',
        backgroundColor: theme.palette.primary.main,
    }),
}));

//
export const createButton = {
    width: '100%',
    py: 0.875,
    mb: '10px',
    borderRadius: '10px',
    fontWeight: 600,
    color: 'common.white',
    background: 'linear-gradient(135deg, #00B37E 0%, #005249 100%)',
    boxShadow: '0 2px 8px rgba(0, 179, 126, 0.4), inset 0 1px 0 rgba(255,255,255,0.15)',
    border: '1px solid rgba(0, 179, 126, 0.3)',
    transition: 'all 0.2s ease',
    '&:hover': {
        background: 'linear-gradient(135deg, #00C98A 0%, #006B5E 100%)',
        boxShadow: '0 4px 16px rgba(0, 179, 126, 0.5), inset 0 1px 0 rgba(255,255,255,0.2)',
        transform: 'translateY(-1px)',
    },
    '&:active': {
        transform: 'translateY(0)',
        boxShadow: '0 1px 4px rgba(0, 179, 126, 0.3)',
    },
    '.MuiButton-startIcon': {
        mr: '16px',
    },
    '.MuiButton-endIcon': {
        ml: '16px',
    },
};

export const badgeStyle = {
    borderRadius: '6px', 
    border: '1px solid #D93C36', 
    p: '1px 8px', 
    fontSize: '12px', 
    fontWeight: '700', 
    color: '#D93C36' 
};
